import { View } from './view'

export const Section = View
